import React, { Component, useState } from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from '@react-google-maps/api';
import { APIHandler, BackButton, PremiumHotel, FreeHotel, StorageHandler } from 'C4';
import { baseAppId, storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

import { Multiselect } from 'multiselect-react-dropdown';

import SimpleBarReact from 'simplebar-react';
import 'simplebar/src/simplebar.css';

import MarkerFree from 'assets/images/ab-mapGrey.png';
import ClusterFree from 'assets/images/ab-mapClusterGrey.png';
import MarkerPremium from 'assets/images/ab-map.png';
import ClusterPremium from 'assets/images/ab-mapCluster.png';

let containerStyle = {
  width: '100%',
  height: 'calc(100vh - 8rem)',
};
const params = new URLSearchParams(window.location.search);
if (params.get('mobile')) {
  containerStyle = {
    width: '100%',
    height: '100vh',
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: 'white',
      textSize: 14,
      fontFamily: 'Source Sans Pro',
    },
  ],
  clusterClass: 'clusterIcon',
};

const checkboxOptions = [
  { name: 'Arts/Culture', id: 'Arts/Culture' },
  { name: 'History/Heritage', id: 'History/Heritage' },
  { name: 'Museums', id: 'Museums' },
  { name: 'Outdoor Recreation', id: 'Outdoor Recreation' },
  { name: 'Shopping/Leisure', id: 'Shopping' },
  { name: 'Food & Drink', id: 'Food & Drink' },
  { name: 'Accommodations', id: 'Accommodations' },
];

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 43.80793957938894,
      lat2: 34.12222671477245,
      lon1: -113.69544004062502,
      lon2: -119.803838478125,
      loading: false,
      query: '',
      category: [],
      width: null,
      mobile: false,
      source: false,
      zoom: 6,
      center: {
        lat: 39.624113,
        lng: -117.2655084,
      },
      color: '0096bb',
      font: 'Source Sans Pro',
      userInfo: '',
      options: [      
        { name: 'Attractions', id: 'category' },
        { name: 'Hotels', id: 'category' },
        { name: 'Dining', id: 'category' },
        { name: 'Nightlife', id: 'category' },
        { name: 'Arts, Culture & History', id: 'category' },
        { name: 'Theme Parks', id: 'category' },
        { name: 'Sports, Recreation & Outdoors', id: 'category' },
        { name: 'Other Accommodations', id: 'category' },
        { name: 'Shopping', id: 'category' },
        { name: 'Wedding Services', id: 'category' },
        { name: 'Medical Services', id: 'category' },
        { name: 'Golf', id: 'category' },
        { name: 'Transportation Services', id: 'category' },
        { name: 'Spas', id: 'category' },
      ],
      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (params.get('source')) {
      this.setState({ source: JSON.parse(params.get('source')) });
    }

    if (width < 800) {
      this.getHotelsList();
    }

    this.getLogo();
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite ? appInfo.logoWhite : null,
      })
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList(),
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
      } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
      ).then(results => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // App ID hardcoded until all are set in backend
    const {
      lat1,
      lat2,
      lon1,
      lon2,
      category,
    } = this.state;

    // Convert to category + convert to array list
    let categoryArr = '';
    if (category.length > 0) {
      category.forEach(function(e){
        console.log(e);
        if (e == 'attraction') {
           e = 2;
        } else if (e == 'accommodation') {
          e = 1;
        } else if (e == 'CVB') {
          e = 7;
        }  
        categoryArr += '&categoryArr[]' + "=" + e + "&";
     });
     console.log(categoryArr);
    }
    APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2, 859, categoryArr).then((results) => {
      this.setState({ premiumHotelsList: results.items });
    });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 6,
      center: {
        lat: 39.624113,
        lng: -117.2655084,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = userInfoID => {
    document.getElementById('iframe').classList.remove('hide');
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  };

  freeInfo = userInfoID => {
    if (this.state.mobile) {
      window.ReactNativeWebView.postMessage(
        `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
      window.postMessage(
        `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
        '*',
      );
    } else {
      document.getElementById('iframe').classList.remove('hide');
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: [
          ...this.state[selectedItem.id],
          selectedItem['name'],
        ],
      },
      () => {
        this.getHotelsList();
      },
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem['name']);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        },
      );
    }
  }

  handleCheck = e => {
    if (this.state.category.includes(e.target.id)) {
      let filteredArray = this.state.category.filter(item => item !== e.target.id)
      this.setState(
        {
          category: filteredArray
        },
        () => {
          this.getHotelsList();
        });
    } else {
      if (e.target.id !== '') {
        this.setState(
          {
            category: this.state.category.concat([e.target.id])
          },
          () => {
            this.getHotelsList();
          },
        );
      }
    }
  };

  closeIframe() {
    document.getElementById('iframe').classList.add('hide');
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      source,
      width,
      loading,
      filterOpen,
      logo
    } = this.state;

    return (
      <div className='directoryContainer'>
        {source && (
            <style>{".cookieConsent { display: none !important; } "}</style>
          )}
        {mobile && (
          <style>
            {
              '\
        .directoryContainer { height: 100vh; } .search { with: 100%; } .backLink { display: none !important; } .listContainer { height: calc(100vh - 8rem) !important; } .search { width: 100% !important; }'
            }
          </style>
        )}
          <div className='header'>
          {!mobile && !source && (<BackButton useHistory={false} text='Back' />)}
            <div className='search'>
              <FontAwesomeIcon
                icon={['fas', 'search']}
                className='searchIcon'
              />
              <input
                className='searchInput'
                placeholder={i18n.translate('nav.search')}
                type='text'
                ref={input => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className='logo' alt='logo' />
          </div>
        <div className='directoryView'>
          <div className='leftSide'>
            <div className='results'>
            {i18n.translate('directory.amount')}:{' '}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className='filter-btn'
              >
                {filterOpen ? 'Close' : 'Filter'}
              </button>
            </div>
            <div className='leftGrid'>
              <div className={`filterContainer ${filterOpen ? 'active' : ''}`}>
                <div className='type'>
                  <Multiselect
                    options={this.state.options}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue='name'
                    placeholder='Filter by Category'
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className='island'>
                  <Multiselect
                    options={this.state.islandOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue='name'
                    placeholder='Filter by Island'
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className='price'>
                  <Multiselect
                    options={this.state.priceOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue='name'
                    placeholder='Filter by Price'
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className='checkboxOptions'>
                  <span className='title'>{i18n.translate('directory.filters')}:</span>
                  {checkboxOptions.map((option, index) => (
                    <div
                      key={index}
                      className='checkboxDiv'
                      id={option.id}
                      onClick={this.handleCheck}
                    >
                      <label id={option.id} onClick={this.handleCheck}>
                        <span
                          className='labelName'
                          id={option.id}
                          onClick={this.handleCheck}
                        >
                          {i18n.translate(`directory.${option.name.replace(/\s/g, '').replace(/&/g, '').replace(/,/g, '').replace(/&/g, '').replace(/,/g, '').replace(/-/g, '').replace('+', '').replace(/:/g, '').toLowerCase().replace('fooddrink', 'foodbeverage').replace('shopping/leasure', 'shopping').replace('outdoorrecreation', 'sportsrecreationoutdoors').replace('outdoorrecreation', 'sportsrecreationoutdoors').replace('arts/culture', 'artsculturehistory').replace('history/heritage', 'history').replace('shopping/leisure', 'shopping')}`)}                    
                        </span>
                        <input
                          type='checkbox'
                          name={option.name}
                          onChange={this.handleCheck}
                        />
                        <span
                          className='checkmark'
                          id={option.id}
                          onClick={this.handleCheck}
                        />
                      </label>
                    </div>
                  ))}
                </div>
                <div
                  className='resetFilters'
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                {i18n.translate('directory.reset')}
                </div>
                <div className='text-center'>
                  <button
                    onClick={this.resetFilters}
                    className='filter-btn inverted'
                  >
                  {i18n.translate('directory.reset')}
                  </button>
                  <button onClick={this.toggleFilter} className='show-results'>
                  {i18n.translate('general.submit')}
                  </button>
                </div>
              </div>

              <SimpleBarReact
                className={`listContainer ${filterOpen ? 'filterOpen' : ''}`}
              >
                <div className='premiumList'>
                  {loading && (
                    <span className='loader'>
                      <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map(hotel => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude,
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className='freeList'>
                  {freeHotelsList.length === 0 && !loading && (
                    <div className='noResults'>
                    {i18n.translate('general.noResultsFor')}
                    </div>
                  )}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map(hotel => (
                      <FreeHotel
                        key={hotel.company_listing_id}
                        id={hotel.company_listing_id}
                        bgImage={hotel.img_path}
                        flyToMarker={() => {
                          this.flyToMarker(hotel.latitude, hotel.longitude);
                        }}
                        hotelInfo={() => {
                          this.freeInfo(hotel.listing_id);
                        }}
                        hotelName={hotel.company}
                        location={hotel.state}
                        item={hotel}
                      />
                    ))}
                  {zoom > 8 && (
                    <div
                      className='resetMap'
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                    {i18n.translate('directory.reset')}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className='rightSide'>
              <LoadScript googleMapsApiKey='AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc'>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={map => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom(),
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {clusterer => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map(freeHotel => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {clusterer => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map(premiumHotel => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude,
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className='iframe hide' id='iframe'>
            <div
              className='bgIframe'
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className='iframeHolder'>
              <div
                className='closeIframe'
                href='#'
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className='closeText'>
                  <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {i18n.translate('general.back')}
                </span>
              </div>
              <div className='contentIframe'>
                <iframe
                  width='100%'
                  height='100%'
                  id='iframeModal'
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
